import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { logger } from "@/lib/logger";

const NotFound = () => {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    logger.info("404 Error: User attempted to access non-existent route", {
      pathname: location.pathname,
      search: location.search,
    });
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">{t("errors.pageNotFound")}</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          {t("errors.returnHome")}
        </a>
      </div>
    </div>
  );
};

export default NotFound;
